"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require("../constants");

var _AutocompleteInput = require("../../AutocompleteInput");

var _AutocompleteInput2 = _interopRequireDefault(_AutocompleteInput);

var _context = require("./context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InputAutocomplete = function InputAutocomplete(props) {
  var _useToolbarContext = (0, _context.useToolbarContext)(),
      testId = _useToolbarContext.testId;

  return _react2.default.createElement("span", {
    className: (0, _classnames2.default)(_constants.ORDER_CLASSNAMES.TOOLBAR_CHILD.INPUT, 'w-40'),
    id: _constants.NAMESPACES.TOOLBAR.INPUT_SEARCH,
    "data-testid": testId + "__input-autocomplete"
  }, _react2.default.createElement(_AutocompleteInput2.default, props));
};

exports.default = InputAutocomplete;